export default class PersonalAccessTokenCreateDto {

    constructor(name: string | null, validityStart: Date | null, validityEnd: Date | null) {
        this.Name = name;
        this.ValidityStart = validityStart;
        this.ValidityEnd = validityEnd;
    }

    Name: string | null;
    ValidityStart: Date | null;
    ValidityEnd: Date | null;
}